module.exports = __webpack_public_path__ + "static/img/c-m-bg3.e211d4c1.png";